import styles from "./app.module.css";
import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import FestList from "../../pages/fest-list/fest-list";
import FoundList from "../../pages/found-list/found-list";
import WriteList from "../../pages/write-list/write-list";
import { useAppDispatch } from "../../types/hook";
import GlagList from "../glag/glag";
import Presente from "../presente/presente";
import PresWrite from "../preswrite/preswrite";
import Perfeito from "../perfeito/perfeito";
import Imperfeito from "../imperfeito/imperfeito";
import PerfWrite from "../perfwrite/perfwrite";
import ImperfeitoWrite from "../imperfeitowriter/imperfeitowriter";
import FrazList from "../fraz/fraz";
import Profile from "../../pages/profile/profile";
import Login from "../../pages/login/login";
import Register from "../../pages/registr/registr";
import ForgotPassword from "../../pages/forgot-password/forgot-password";
import { setUser, clearUser } from "../../store/authSlice";
import ManyList from "../many/many";
import GlagFraz from "../glag-present/glag-present";
import PredGlag from "../glagpred/glagpred";
import PredAll from "../predall/predall";
import PredConst from "../predconst/predconst";
import PredConstHard from "../predconsthard/predconsthard";
import ResetPassword from "../../pages/reset-password/reset-password";
import Chat from "../chat/chat";
import End from "../end/end";
import Palavra from "../../pages/palavra/palavra";
import Palavrab from "../../pages/palavrab/palavrab";
import Verbo from "../../pages/verbo/verbo";
import Words from "../../pages/words/words";
import StartPage from "../../pages/startpage/startpage";
import MenuPage from "../../pages/menupage/menupage";
import Frazs from "../../pages/frazs/frazs";
import { ProtectedRoute } from "../../hoc/protectRout";
import { getAuth, onAuthStateChanged } from "firebase/auth";

function App() {
  const dispatch = useAppDispatch();

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch(
          setUser({
            uid: user.uid,
            email: user.email,
            name: user.displayName,
            photoURL: user.photoURL,
          })
        );
      } else {
        dispatch(clearUser());
      }
    });

    return () => unsubscribe();
  }, [dispatch, auth]); // <-- теперь ESLint доволен

  useEffect(() => {
    document.title = "Европейский португальский с Тоби";
  }, []);

  return (
    <div className={styles.app}>
      <Routes>
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/predall"
          element={
            <ProtectedRoute>
              <PredAll />
            </ProtectedRoute>
          }
        />
        <Route path="/predconst" element={<PredConst />} />
        <Route path="/predconsthard" element={<PredConstHard />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route path="/glag" element={<GlagList />} />
        <Route path="/learn" element={<FestList />} />
        <Route path="/feed" element={<FoundList />} />
        <Route path="/write" element={<WriteList />} />
        <Route path="/presente" element={<Presente />} />
        <Route path="/preswrite" element={<PresWrite />} />
        <Route path="/perfeito" element={<Perfeito />} />
        <Route path="/prefwrite" element={<PerfWrite />} />
        <Route path="/imperfeito" element={<Imperfeito />} />
        <Route path="/many" element={<ManyList />} />
        <Route path="/fraz" element={<FrazList />} />
        <Route path="/imperfeitowriter" element={<ImperfeitoWrite />} />
        <Route path="/predglag" element={<PredGlag />} />
        <Route path="/presglag" element={<GlagFraz />} />
        <Route
          path="/palavraaone"
          element={
            <ProtectedRoute>
              <Palavra />
            </ProtectedRoute>
          }
        />
        <Route
          path="/palavrabone"
          element={
            <ProtectedRoute>
              <Palavrab />
            </ProtectedRoute>
          }
        />
        <Route
          path="/verbo"
          element={
            <ProtectedRoute>
              <Verbo />
            </ProtectedRoute>
          }
        />
        <Route path="/palavra/all" element={<Words />} />
        <Route path="/cardfraz" element={<Frazs />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route
          path="/resetpassword"
          element={
            <ProtectedRoute>
              <ResetPassword />
            </ProtectedRoute>
          }
        />
        <Route path="/register" element={<Register />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<StartPage />} />
        <Route path="*" element={<StartPage />} />
      </Routes>
      <End></End>
    </div>
  );
}

export default App;
//<Route path="/profile" element={<OnlyAuth component={<Profile />} />} />
/*return (
    <div className={styles.app}>
      <Routes>
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/predall"
          element={
            <RequireAuth>
              <PredAll />
            </RequireAuth>
          }
        />
        <Route path="/predconst" element={<PredConst />} />
        <Route path="/predconsthard" element={<PredConstHard />} />
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route path="/glag" element={<GlagList />} />
        <Route path="/learn" element={<FestList />} />
        <Route path="/feed" element={<FoundList />} />
        <Route path="/write" element={<WriteList />} />
        <Route path="/presente" element={<Presente />} />
        <Route path="/preswrite" element={<PresWrite />} />
        <Route path="/perfeito" element={<Perfeito />} />
        <Route path="/prefwrite" element={<PerfWrite />} />
        <Route path="/imperfeito" element={<Imperfeito />} />
        <Route path="/many" element={<ManyList />} />
        <Route path="/fraz" element={<FrazList />} />
        <Route path="/imperfeitowriter" element={<ImperfeitoWrite />} />
        <Route path="/predglag" element={<PredGlag />} />
        <Route path="/presglag" element={<GlagFraz />} />
        <Route
          path="/palavraaone"
          element={
            <RequireAuth>
              <Palavra />
            </RequireAuth>
          }
        />
        <Route
          path="/palavrabone"
          element={
            <RequireAuth>
              <Palavrab />
            </RequireAuth>
          }
        />
        <Route
          path="/verbo"
          element={
            <RequireAuth>
              <Verbo />
            </RequireAuth>
          }
        />
        <Route path="/palavra/all" element={<Words />} />
        <Route path="/cardfraz" element={<Frazs />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route
          path="/resetpassword"
          element={
            <RequireAuthc>
              <ResetPassword />
            </RequireAuthc>
          }
        />
        <Route
          path="/register"
          element={
            <RequireAuthc>
              <Register />
            </RequireAuthc>
          }
        />
        <Route
          path="/forgotpassword"
          element={
            <RequireAuthc>
              <ForgotPassword />
            </RequireAuthc>
          }
        />
        <Route
          path="/login"
          element={
            <RequireAuthc>
              <Login />
            </RequireAuthc>
          }
        />
        <Route path="/" element={<StartPage />} />
        <Route path="*" element={<StartPage />} />
      </Routes>
      <End></End>
    </div>
  );
}*/
